function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#F6C254",
  d: "M0 0h15v13H0z"
});

function SvgYellowRectangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 13",
    fill: "none"
  }, props), _ref);
}

export default SvgYellowRectangle;